import React from 'react';
import { useLocation } from 'react-router-dom';
import { Info, Shield, Lock } from 'lucide-react';
import { useDemo } from '../contexts/DemoContext';
import { cn } from '../lib/utils';

export const DemoAnnotation = ({ children, type = 'info', className }) => {
  const { showAnnotations } = useDemo();

  if (!showAnnotations) return null;

  const icons = {
    info: Info,
    governance: Shield,
    security: Lock,
  };

  const colors = {
    info: 'bg-[hsl(var(--badge-info-bg))] border-[hsl(var(--badge-info-border))] text-muted-foreground',
    governance: 'bg-[hsl(var(--badge-success-bg))] border-[hsl(var(--badge-success-border))] text-[hsl(var(--badge-success-text))]',
    security: 'bg-[hsl(var(--badge-warning-bg))] border-[hsl(var(--badge-warning-border))] text-[hsl(var(--badge-warning-text))]',
  };

  const Icon = icons[type];

  return (
    <div className={cn('flex items-start gap-2 p-3 rounded-lg border text-xs', colors[type], className)}>
      <Icon className="h-4 w-4 flex-shrink-0 mt-0.5" />
      <div className="flex-1">{children}</div>
    </div>
  );
};

export const DemoBadge = () => {
  const { demoMode } = useDemo();
  const { pathname } = useLocation();

  if (!demoMode) return null;
  // Surfaces that label their own simulation state do it better than this
  // badge does, and this badge overlaps their content. It stands down on:
  //   /sandbox/*          — evaluator surfaces, header + every decision
  //   /programs/console   — header reads "SIMULATED — no partner connected"
  //   /farmer             — persistent SIMULATED footer
  // The check is on the live route, not the route this component first
  // mounted at: these surfaces are usually reached by client-side navigation.
  const SELF_LABELLED = ['/sandbox/', '/programs/console', '/farmer'];
  if (SELF_LABELLED.some((route) => pathname.startsWith(route))) return null;

  return (
    <div className="fixed top-20 right-4 z-50 bg-muted/90/90 text-muted-foreground dark:text-muted-foreground px-3 py-1 rounded text-[10px] font-medium shadow-sm">
      Simulation Environment
    </div>
  );
};